import { useState, useEffect } from 'react';
import { apiClient } from '../apiClient';

type AuthenticatedImageProps = {
    src: string;
    alt: string;
    className?: string;
};

export function AuthenticatedImage({ src, alt, className }: AuthenticatedImageProps) {
    const [imageUrl, setImageUrl] = useState<string | null>(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        let objectUrl: string | null = null;

        async function loadImage() {
            try {
                // Use apiClient to get the image as a blob, which includes auth headers
                const response = await apiClient.get(src, {
                    responseType: 'blob',
                });
                
                objectUrl = URL.createObjectURL(response.data);
                setImageUrl(objectUrl);
            } catch (err) {
                console.error('Failed to load authenticated image:', err);
                setError(true);
            }
        }

        if (src) {
            loadImage();
        }

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [src]);

    if (error) {
        return (
            <div className={`${className} image-error`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <polyline points="21 15 16 10 5 21" />
                </svg>
            </div>
        );
    }

    if (!imageUrl) {
        return <div className={`${className} image-loading`} />;
    }

    return <img src={imageUrl} alt={alt} className={className} />;
}
